import _classCallCheck from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/createClass.js";
var GraphicsData = /*#__PURE__*/function () {
  function GraphicsData(shape) {
    var fillStyle = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
    var lineStyle = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
    var matrix = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
    _classCallCheck(this, GraphicsData);
    this.points = [];
    this.holes = [];
    this.shape = shape;
    this.lineStyle = lineStyle;
    this.fillStyle = fillStyle;
    this.matrix = matrix;
    this.type = shape.type;
  }
  _createClass(GraphicsData, [{
    key: "clone",
    value: function clone() {
      return new GraphicsData(this.shape, this.fillStyle, this.lineStyle, this.matrix);
    }
  }, {
    key: "destroy",
    value: function destroy() {
      this.shape = null;
      this.holes.length = 0;
      this.holes = null;
      this.points.length = 0;
      this.points = null;
      this.lineStyle = null;
      this.fillStyle = null;
    }
  }]);
  return GraphicsData;
}();
export { GraphicsData };